"use client";

import { cn } from "@/helpers/cn";

interface LiveBannerProps {
  message: string;
  className?: string;
}

export function LiveBanner({ message, className }: LiveBannerProps) {
  return (
    <div
      className={cn(
        "relative flex items-center justify-center gap-3 py-3 px-6 font-mono text-xs uppercase tracking-wider text-spicenet-black border border-spicenet-primary/15 bg-spicenet-primary/5",
        className,
      )}
    >
      {/* Corner crosses */}
      <span className="absolute top-1.5 left-2 text-spicenet-primary/30 text-[10px] leading-none select-none">+</span>
      <span className="absolute top-1.5 right-2 text-spicenet-primary/30 text-[10px] leading-none select-none">+</span>
      <span className="absolute bottom-1.5 left-2 text-spicenet-primary/30 text-[10px] leading-none select-none">+</span>
      <span className="absolute bottom-1.5 right-2 text-spicenet-primary/30 text-[10px] leading-none select-none">+</span>

      {/* Dot grid pattern overlay */}
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle, var(--spicenet-primary) 1px, transparent 1px)",
          backgroundSize: "12px 12px",
        }}
      />

      {/* Content */}
      <span className="relative flex h-2 w-2 shrink-0">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-spicenet-primary opacity-75" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-spicenet-primary" />
      </span>
      <span className="relative font-semibold text-spicenet-primary">Live</span>
      <span className="relative text-spicenet-black/60">{message}</span>
    </div>
  );
}
